import React from 'react';
import { Paper, styled } from '@mui/material';

export interface PayPaperProps {
    children?: React.ReactNode;
}

const PayPaperVertical = styled(Paper)({
    borderRadius: 13,
    paddingBottom: 15,
    paddingTop: 42,
});

const PayPaper = styled(PayPaperVertical)({
    paddingLeft: 32,
    paddingRight: 32,
    width: '100%',
    marginBottom: 20,
});

const PayBackgroundPaper = ({ children }: PayPaperProps) => {
    return <PayPaper elevation={4}>{children}</PayPaper>;
};

export { PayBackgroundPaper };
